import React, { useEffect, useMemo, useState } from "react";
import AdminClient from "../AdminClient";
import BasicTable from "../components/basic/BasicTable";
import utils from "../utils";
import { FormControlLabel, Switch, useMediaQuery } from "@mui/material";
import TextHTMLRender from "./renders/TextHTMLRender";
import { Chip, Stack, Box, Typography } from "@mui/material";


const NotificationPills = (props) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <Stack spacing={1} sx={{ width: "100%" }}>
        {props.notifications.map((notification) => (
          <Box
            key={notification.id}
            sx={{ alignItems: "center", width: "100%", border: "1px solid #ccc", padding: 1, borderRadius: 1 }}
          >
            <div style={{ width: "100%", alignItems: "center" }}>
              <h2>{notification.title}</h2>
              <h3>{notification.created_date}</h3>
              <div style={{float:"right"}}>{props.t("Mark as read")} <Switch
                size="small"
                onClick={()=>{props.setNotified(notification)}}
              />
              </div>
              <hr style={{ width: "100%", border: "solid 1px black" }}></hr>
            </div>
            <div style={{ width: "100%", alignItems: "center" }}
              variant="body2"
              sx={{ marginLeft: 1, wordWrap: "break-word", flexGrow: 1 }}
              dangerouslySetInnerHTML={{ __html: notification.content }}
            >
            </div>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

const AdminNotifications = (props) => {
  const adminClient = new AdminClient();
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const [notifications, setNotifications] = useState([]);
  const isMobile = useMediaQuery("(max-width: 1300px)");
  utils.setSessionItem("showAdminNotifications", false);

  const { t } = props;

  function setNotified(notification) {
    adminClient
      .updateStatusAdminNotification(
        session,
        company,
        notification.notification
      )
      .then((result) => {
        setNotifications(result.data);
      });

  }
  const columnsDef = isMobile
    ? [
      {
        Header: t("Content"),
        accessor: "content",
        typeCell: "text",
      },
    ]
    : [
      {
        Header: t("Created date"),
        accessor: "created_date",
        typeCell: "time",
      },
      {
        Header: t("Title"),
        accessor: "title",
        typeCell: "text",
      },

      {
        Header: t("Content"),
        accessor: "content",
        typeCell: "text",
        Cell: (props) => {
          return <TextHTMLRender value={props.row.original.content} />;
        },
      },
      {
        Header: t("Mark as read"),
        accesor: "",
        typeCell: "text",
        Cell: (props) => {
          return (
            <Switch
              size="small"
              onClick={(evt) => {
                adminClient
                  .updateStatusAdminNotification(
                    session,
                    company,
                    props.row.original.notification
                  )
                  .then((result) => {
                    setNotifications(result.data);
                  });
              }}
            />
          );
        },
      },
    ];

  useEffect(() => {
    adminClient.getAdminNotifications(session).then(
      (result) => {
        setNotifications(result.data);
      },
      (err) => { }
    );
  }, []);

  return (
    <>
      {notifications.length > 0 && (
        <>
          <FormControlLabel
            control={
              <Switch
                onClick={(evt) => {
                  adminClient
                    .updateStatusAdminNotification(session, company, "")
                    .then((result) => {
                      setNotifications(result.data);
                    });
                }}
              />
            }
            label={t("Mark all as read")}
          />
          {false &&
          <div className="adminNotifications-desktop">
            <BasicTable
              data={notifications}
              columns={columnsDef}
              hidePagination={isMobile ? true : undefined}
              hideHeader={isMobile ? true : undefined}
            />
          </div>
}
          <div className="adminNotifications-mobile">
            <NotificationPills notifications={notifications} setNotified={setNotified} t={t}/>
          </div>
        </>
      )}
      {notifications.length === 0 && (
        <span>{t("No existen Notificaciones")}</span>
      )}
    </>
  );
};

export default AdminNotifications;
